import React, { useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { fmtMoney } from './paymentUtils';

export const IgnoreDialog = ({ payment, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');
  const [alwaysIgnore, setAlwaysIgnore] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!payment) return null;

  const submit = async () => {
    setBusy(true);
    await onConfirm(payment, { reason: reason.trim(), alwaysIgnore });
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="ignore-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>Ignore payment</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">
          {payment.counterparty_name} · {fmtMoney(payment.amount)}. No QuickBooks bill is expected.
        </p>
        <input
          data-testid="ignore-reason-input"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason (optional), e.g. Payroll"
          className="w-full border rounded-md px-3 py-2 text-sm"
        />
        <label className="flex items-start gap-2 text-sm text-slate-700">
          <input type="checkbox" data-testid="ignore-always-checkbox" checked={alwaysIgnore}
            disabled={!payment.counterparty_id} onChange={(e) => setAlwaysIgnore(e.target.checked)} className="mt-1" />
          <span>
            Always ignore this payee
            <span className="block text-xs text-slate-500">Future payments to {payment.counterparty_name} are ignored automatically.</span>
          </span>
        </label>
        <DialogFooter>
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm border rounded-md">Cancel</button>
          <button type="button" data-testid="ignore-confirm-btn" onClick={submit} disabled={busy}
            className="px-4 py-2 text-sm rounded-md bg-slate-900 text-white disabled:opacity-50">Ignore</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
